import { Fragment, useContext, useState } from "react";
import { useNavigate } from "react-router";
import { Button } from "rizzui";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import cn from "../../../utils/classNames";
import InvoicesList from "./InvoicesList";
import ExportByDatesModal from "../components/ExportByDatesModal";

interface InvoicesListWrapperProps {
    type?: 'proforma' | 'invoice';
}

const InvoicesListWrapper = ({ type = 'proforma' }: InvoicesListWrapperProps) => {

    // STATES

    const [openFormDrawer, setOpenFormDrawer] = useState<boolean>(false);
    const [invoiceSelected, setInvoiceSelected] = useState<any | null>(null);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    
    const isProforma = type === 'proforma';

    const breadCrumb = [
        { name: 'Administración' },
        { name: isProforma ? 'Proformas' : 'Facturas', href: isProforma ? menuRoutes.invoices.proformas : menuRoutes.invoices.facturas }
    ];

    // HOOKS

    const { userCan } = useContext(PrivilegeContext);
    const navigate = useNavigate();


    // FUNCTIONS

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CERRAR MODAL DE DESCARGAR FACTURAS PROVENIENTE BLOB EN FORMATO ZIP
     * @EN CLOSE MODAL OF DOWNLOAD INVOICES FROM BLOB IN ZIP FORMAT
     */
    const onClose = () => {
        setIsOpen(false);
    }
    // -------------------------------------------------------------------------------------------------------------
    

    // RENDER

    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={{ is_paid: !isProforma }}>
                <PageHeader title={isProforma ? "Listado de proformas" : "Listado de facturas"} breadcrumb={breadCrumb}>
                    <div>
                        {userCan('export', 'invoice') &&
                            (
                                <Button
                                    color="secondary"
                                    onClick={() => {
                                        setIsOpen(true)
                                    }}
                                    className={cn(['mt-4 md:mt-0'])}
                                >
                                    {isProforma ? "Exportar proformas por fechas" : "Exportar facturas por fechas"}
                                </Button>
                            )
                        }
                        {userCan('create', 'invoice') &&
                            (
                                <Button
                                    color="primary"
                                    onClick={() => {
                                        setOpenFormDrawer(true)
                                        setInvoiceSelected(null)
                                    }}
                                    className={cn(['mt-4 md:mt-0 mx-2'])}
                                >
                                    {isProforma ? "Emitir proforma" : "Emitir factura"}
                                </Button>
                            )
                        }
                    </div>
                </PageHeader>
                <InvoicesList 
                    openFormDrawer={openFormDrawer} 
                    setOpenFormDrawer={setOpenFormDrawer} 
                    invoiceSelected={invoiceSelected} 
                    setInvoiceSelected={setInvoiceSelected}
                    type={type}
                />
                <ExportByDatesModal isOpen={isOpen} onClose={onClose} type={type} />
            </FiltersProvider>
        </Fragment>
    );
}

export default InvoicesListWrapper;